import React from 'react';
import { 
  SiReact, SiNextdotjs, SiNodedotjs, SiTailwindcss, SiTypescript, SiJavascript, SiHtml5,
  SiMongodb, SiPostgresql, SiFirebase, SiDocker, SiGithub, SiGit, SiVercel, SiFigma,
  SiRedux, SiGraphql, SiSass, SiJest, SiPython, SiPostman, SiExpress, SiCloudflare,
  SiPrisma, SiSupabase, SiFramer, SiWebgl, SiBootstrap, SiRedwoodjs, SiZod, SiTurborepo
} from 'react-icons/si';

const techStack = [
  { name: "React", icon: SiReact, color: "#61DAFB" }, { name: "Next.js", icon: SiNextdotjs, color: "#3776AB" }, 
  { name: "Node.js", icon: SiNodedotjs, color: "#339933" }, { name: "Tailwind", icon: SiTailwindcss, color: "#06B6D4" }, 
   { name: "JS", icon: SiJavascript, color: "#F7DF1E" }, 
  { name: "HTML5", icon: SiHtml5, color: "#E34F26" }, { name: "MongoDB", icon: SiMongodb, color: "#47A248" },
  { name: "PostgreSQL", icon: SiPostgresql, color: "#4169E1" }, { name: "Firebase", icon: SiFirebase, color: "#FFCA28" }, 
  { name: "Docker", icon: SiDocker, color: "#2496ED" }, { name: "GitHub", icon: SiGithub, color: "#C21325" }, 
  { name: "Git", icon: SiGit, color: "#F05032" }, 
  { name: "Figma", icon: SiFigma, color: "#F24E1E" }, { name: "Redux", icon: SiRedux, color: "#764ABC" },
  { name: "GraphQL", icon: SiGraphql, color: "#E10098" }, { name: "Sass", icon: SiSass, color: "#CC6699" }, 
  { name: "Jest", icon: SiJest, color: "#C21325" },  
  { name: "Postman", icon: SiPostman, color: "#FF6C37" }, { name: "Express", icon: SiExpress, color: "#F7DF1E" }, 
  { name: "Cloudflare", icon: SiCloudflare, color: "#F38020" }, 
  { name: "Supabase", icon: SiSupabase, color: "#3ECF8E" }, { name: "Framer", icon: SiFramer, color: "#0055FF" }, 
  { name: "WebGL", icon: SiWebgl, color: "#990000" }, { name: "Bootstrap", icon: SiBootstrap, color: "#7952B3" }, 
 ];

const Webdevtool = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
     <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* CONTENT CARD */}
      <div className="relative z-10 max-w-7xl mx-auto bg-white dark:bg-[#111] p-8 md:p-12 rounded-lg border border-gray-100 dark:border-gray-800 shadow-sm">
            <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
              Tech stack and {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
             Tools
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
  We leverage modern tools and technologies to deliver fast, responsive, and high-performance websites that ensure the best user experience.
</p>
      </div>
        
        <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-8">
          {techStack.map((item, index) => (
            <div key={index} className="flex flex-col items-center gap-3 group cursor-pointer">
              <div className="p-4 bg-gray-50 dark:bg-[#1a1a1a] rounded-2xl border border-gray-100 dark:border-gray-800 group-hover:scale-110 group-hover:border-orange-500/50 transition-all duration-300">
                <item.icon className="w-8 h-8" style={{ color: item.color }} />
              </div>
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider group-hover:text-orange-500 transition-colors">
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Webdevtool;